export default {
	props: ['detailed']
}


// WEBPACK FOOTER //
// ./src/common/Footer/footer.js